<template>
  <div id="app">
    <app-header v-if="$route.meta.requiresAuth"></app-header>
    <router-view/>
    <b-modal id="modal-error" ref="modalError" class="html-header-footer">
        <div slot="modal-footer">
        </div>
        <div slot="modal-header">
        </div>
        <div class="modal-content p-3 text-center">
            <h3>
            <strong>Erreur</strong>
            </h3>
            <p>{{$t(getError)}}</p>
            <div class="text-center">
            <button type="button" class="btn btn-info round" v-on:click="resetErrors()">Ok</button>
            </div>
        </div>
    </b-modal>

  </div>
</template>
<script>
import Header from './components/layout/header.vue'

export default {
  components: {
    'app-header': Header
  },
  computed: {
    currentErrors () {
      return this.$store.getters.getErrorResponse
    },
    getError () {
      if (typeof this.currentErrors.error === 'string') {
        return this.currentErrors.error
      } else {
        let res = []
        for (let prop in this.currentErrors.error) {
          if (prop === 'first_name') {
            res.push('first_name_too_long')
          } else if (prop === 'last_name') {
            res.push('last_name_too_long')
          } else {
            res.push(this.currentErrors.error[prop])
          }
        }
        return res.join('<br/>')
      }
    }
  },
  methods: {
    resetErrors () {
      this.$store.dispatch('resetErrorResponse')
      this.$refs.modalError.hide()
    }
  },
  watch: {
    currentErrors: function (newResponse, oldResponse) {
      if (newResponse.error) {
        this.$refs.modalError.show()
      }
    }
  }
}

</script>

<style lang="scss">
@import 'app-assets/app';
</style>
